export function MomentCollectorIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8 12h8l4 8 4-16 4 12 4-4h8" />
      <rect x="10" y="28" width="28" height="12" rx="2" />
      <line x1="18" y1="28" x2="18" y2="40" />
      <line x1="24" y1="28" x2="24" y2="40" />
      <line x1="30" y1="28" x2="30" y2="40" />
    </svg>
  );
}
